import React from 'react'
import { logError } from '../lib/logger'

function createErrorId() {
  try {
    const uuid = globalThis?.crypto?.randomUUID?.()
    if (uuid) return uuid
  } catch {}
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
}

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorId: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error, errorId: createErrorId() }
  }

  componentDidCatch(error, info) {
    try {
      logError('ui_render_error', error, { errorId: this.state.errorId, componentStack: info?.componentStack || null, context: this.props.context || null })
    } catch {}
  }

  render() {
    if (!this.state.hasError) return this.props.children

    const title = this.props.title || 'Ocorreu um erro ao carregar esta tela'
    let showTechnicalDetails = false
    try {
      showTechnicalDetails = import.meta?.env?.MODE === 'development'
    } catch {}

    return (
      <div className="p-6 md:p-10">
        <div className="max-w-2xl rounded-xl border border-slate-800 bg-slate-900/60 p-5">
          <div className="text-white font-bold text-lg">{title}</div>
          <div className="text-slate-400 mt-2 text-sm">Se isto aconteceu após um refresh, pode ser um chunk/asset que não carregou corretamente.</div>
          <div className="mt-4 text-xs text-slate-400 font-mono whitespace-pre-wrap break-words">
            Código do erro: {this.state.errorId || 'desconhecido'}
          </div>
          <div className="flex flex-wrap gap-2 mt-4">
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="px-4 py-2 rounded-lg bg-slate-800 text-slate-100 font-bold hover:bg-slate-700 transition"
            >
              Recarregar
            </button>
            <button
              type="button"
              onClick={() => {
                try {
                  this.setState({ hasError: false, error: null, errorId: null })
                } catch {}
              }}
              className="px-4 py-2 rounded-lg bg-slate-950 text-slate-200 font-bold hover:bg-slate-900 transition border border-slate-800"
            >
              Tentar novamente
            </button>
          </div>
          {showTechnicalDetails ? (
            <div className="mt-4 text-xs text-slate-500 font-mono whitespace-pre-wrap break-words">
              {String(this.state.error?.message || this.state.error || '')}
            </div>
          ) : null}
        </div>
      </div>
    )
  }
}

